import React from "react";
import ReactDOM from "react-dom";
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

const CHUNK_RELOAD_ONCE_KEY = "__chunk_reload_once__";

const chunkErrorText = (errorLike) => {
  if (!errorLike) return "";
  if (typeof errorLike === "string") return errorLike;
  if (typeof errorLike.message === "string") return errorLike.message;
  try {
    return JSON.stringify(errorLike);
  } catch (error) {
    return String(errorLike);
  }
};

const isChunkLoadError = (errorLike) => {
  const text = chunkErrorText(errorLike);
  return /ChunkLoadError|Loading chunk [\w-]+ failed|CSS_CHUNK_LOAD_FAILED/i.test(text);
};

const reloadOnceForChunkError = () => {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") return false;
  if (sessionStorage.getItem(CHUNK_RELOAD_ONCE_KEY) === "1") return false;
  sessionStorage.setItem(CHUNK_RELOAD_ONCE_KEY, "1");
  window.location.reload();
  return true;
};

window.addEventListener("unhandledrejection", (event) => {
  if (!event) return;
  if (isChunkLoadError(event.reason)) {
    event.preventDefault?.();
    reloadOnceForChunkError();
  }
});

window.addEventListener("error", (event) => {
  if (!event) return;
  const target = event.target;
  if (
    target &&
    target.tagName === "SCRIPT" &&
    typeof target.src === "string" &&
    target.src.includes("/static/js/")
  ) {
    reloadOnceForChunkError();
    return;
  }
  if (isChunkLoadError(event.error || event.message)) {
    reloadOnceForChunkError();
  }
}, true);

const applyImpersonationFromUrl = () => {
  if (typeof window === "undefined" || !window.location || !window.location.search) {
    return;
  }
  const params = new URLSearchParams(window.location.search);
  const impersonationId = params.get("impersonation");
  if (!impersonationId) return;

  const storageKey = `impersonation:${impersonationId}`;
  const raw = localStorage.getItem(storageKey);
  if (!raw) {
    params.delete("impersonation");
    const nextUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}${window.location.hash || ""}`;
    window.history.replaceState({}, "", nextUrl);
    return;
  }

  try {
    const payload = JSON.parse(raw);
    if (payload && payload.token && payload.user) {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("token", JSON.stringify(payload.token));
        sessionStorage.setItem("user", JSON.stringify(payload.user));
      }
    }
  } catch (error) {
    // Sessizce geç; geçersiz payload olabilir.
  } finally {
    localStorage.removeItem(storageKey);
    params.delete("impersonation");
    const nextUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}${window.location.hash || ""}`;
    window.history.replaceState({}, "", nextUrl);
  }
};

applyImpersonationFromUrl();

// antd TextArea ResizeObserver loop hatasını sustur (zararsız, sonraki frame'de retry eder)
// capture: true → CRA overlay'inden önce yakalar
window.addEventListener('error', function(e) {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);
// window.onerror da kapat (CRA bazen bunu kullanır)
const _origOnError = window.onerror;
window.onerror = function(msg) {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) {
    return true; // true = tarayıcı varsayılan işlemeyi durdurur
  }
  return _origOnError ? _origOnError.apply(this, arguments) : false;
};

// react-router-redux ve react-redux v5 eski lifecycle uyarılarını sustur
// Kendi kodumuz UNSAFE_ prefix ile güncellendi. Kalanlar 3. parti kütüphanelerden.
const _consoleError = console.error.bind(console);
console.error = (...args) => {
  const msg = typeof args[0] === 'string' ? args[0] : '';
  if (msg.includes('componentWill')) return;
  if (msg.includes('style property during rerender')) return;
  _consoleError(...args);
};

const _consoleWarn = console.warn.bind(console);
console.warn = (...args) => {
  const msg = typeof args[0] === 'string' ? args[0] : '';
  if (msg.includes('componentWill')) return;
  if (msg.includes('whole package of antd')) return;
  if (msg.includes('Google Maps JavaScript API')) return;
  _consoleWarn(...args);
};

const render = Component => {
  ReactDOM.render(
      <Component/>,
      document.getElementById('root')
  );
};

const NextApp = require('./NextApp').default;

// Service Worker'ı KAYITMA — kaldır. Eski CRA SW'si her deploy'da eski uygulamayı
// cache'ten servis edip yeni route'ların (ör. /c/<slug>) görünmemesine yol açıyordu.
// Kayıtlı SW'leri sil ve cache'leri temizle → deploy'lar anında yansır.
try {
  unregisterServiceWorker();
  if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister())).catch(() => {});
  }
  if (typeof caches !== 'undefined' && caches.keys) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
} catch (_e) { /* yoksay */ }

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    const HotNextApp = require('./NextApp').default;
    render(HotNextApp);
  });
}
